import { LocalStorageService } from './../../../../core/services/local-storage.service';
import { environment } from './../../../../../environment/environment';
import {
  NgSignaturePadOptions,
  SignaturePadComponent,
} from '@almothafar/angular-signature-pad';
import { Component, ElementRef, SecurityContext, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ISort } from './../../../../core/models/call-offer';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject, takeUntil } from 'rxjs';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { DatePipe } from '@angular/common';
import { PrimeNGConfig } from 'primeng/api';
import { PageEvent } from '@angular/material/paginator';
import { EvaluationService } from '@core/services/evaluation/evaluation.service';
import { serverError } from '@core/models/messages';
import { ToastrService } from 'ngx-toastr';

const DOMPurify = require('dompurify')

@Component({
  selector: 'app-pv-evaluation',
  templateUrl: './pv-evaluation.component.html',
  styleUrls: ['./pv-evaluation.component.css'],
})
export class PvEvaluationComponent {
  parentItem = 'Oups, Aucune donnée disponible pour le moment.';
  @ViewChild('signature', { static: true })
  signaturePad!: SignaturePadComponent;
  type = [
    { id: 'Annuelle', name: 'Annuelle' },
    { id: 'Suivi', name: 'Suivi' },
  ];
  signatureStatuses = [
    { id: 1, name: 'Non Signé' },
    { id: 2, name: 'Signé par entreprise' },
    { id: 3, name: 'Signé par consultant' },
  ];
  urlimage: string = environment.baseUrlGalery;
  urlcv: string = environment.baseUrlGaleryCv;
  modalRef?: BsModalRef;
  currentUser: any;
  currentSortDirection: number = 2;
  pagination : boolean =false;

  url: string = environment.baseUrl + '/api/Pv/file/signature_files/';
  totalPvs: any;
  // searchForm: FormGroup = this.createSearchForm();
  public signaturePadOptions: NgSignaturePadOptions = {
    minWidth: 1,
    canvasWidth: 300,
    canvasHeight: 250,
    backgroundColor: '#ffffff',
  };
  private signatureDataUrl: string | null = null;
  loadSpinnerTable: boolean = false;
  totalItems!: number;
  totalEvaluation: any;
  searchForm: FormGroup = this.createSearchForm();

  private unsubscribeAll: Subject<void> = new Subject();

  startSearching:boolean = false;

  pageSizeOptions = [5, 10, 20];
  pageSize = 5;
  currentPage = 0;
  totalElements = 0
  pvList: any;
  safeDescription!: SafeHtml;

  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private modalService: BsModalService,
    private localStorageService: LocalStorageService,
    private elRef: ElementRef,
    private sanitizer: DomSanitizer,
    private datePipe: DatePipe,
    private primengConfig: PrimeNGConfig,
    private evaluationService : EvaluationService,
    private toastrService: ToastrService,
  ) {
    this.primengConfig.setTranslation({
      dayNames: ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"],
      dayNamesShort: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
      dayNamesMin: ["D", "L", "M", "M", "J", "V", "S"],
      monthNames: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
      monthNamesShort: ["Jan", "Fév", "Mar", "Avr", "Mai", "Juin", "Juil", "Aoû", "Sep", "Oct", "Nov", "Déc"],
      today: 'Aujourd\'hui',
      clear: 'Effacer'
    });
  }

  ngOnInit(): void {
    this.getPvList();
    const scrollableTable = this.elRef.nativeElement.querySelector('#kt_customers_table');
    scrollableTable?.addEventListener('scroll', this.closeDropdownOnScroll.bind(this));
  }
  closeDropdownOnScroll(): void {
    // Find the open dropdown
    const dropdown = this.elRef.nativeElement.querySelector('.dropdown-menu.show');
    
    // If the dropdown is open, remove the 'show' class to close it without triggering a page scroll
    if (dropdown) {
      dropdown.classList.remove('show');
    }
  }
  updateDescription(description: string) {
    const sanitizedHtml = DOMPurify.sanitize(description);
    this.safeDescription = this.sanitizer.bypassSecurityTrustHtml(sanitizedHtml);
  }
  reset() {
    this.searchForm.reset();
    this.currentPage = 0
    this.getPvList();
  }

  addSigned(id: any) {
    this.router.navigate(['/evaluation/ajout-question', { id: id }]);
  }
  detailPV(id: any) {
    this.router.navigate(['/evaluation/details-pv', { id: id }]);
  }
  downloadSignature() {
    this.signatureDataUrl = this.signaturePad?.toDataURL();
    this.convertBase64ToImage(this.signatureDataUrl);
  }
  convertBase64ToImage(base64Data: string) {
    const image = new Image();
    image.src = base64Data;

    const downloadLink = document.createElement('a');
    downloadLink.href = base64Data;
    downloadLink.download = 'signature.png';

    const container = document.getElementById('imageContainer');
    if (container) {
      container.innerHTML = '';
      container.appendChild(image);
      container.appendChild(downloadLink);
      downloadLink.click();
    }
  }

  createSearchForm(data?: any) {
    return this.formBuilder.group({
      signature_status: [data ? data.signature_status : null],
      evaluation_name: [data ? data?.evaluation_name : null],
      evaluation_type: [data ? data?.evaluation_type : null],
      consultant_name: [data ? data.consultant_name : ''],
      start_date: [data ? data.start_date : ''],
      end_date: [data ? data.end_date : ''],
    });
  }


  openModalCompteRendu(template: TemplateRef<any>, report: any) {
    this.modalRef = this.modalService.show(template);
    const rawHtml = report || '';
    this.safeDescription = this.sanitizer.bypassSecurityTrustHtml(rawHtml);

  }
  htmlToPlainText(html: string): string {
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.textContent || div.innerText || '';
  }

  closeModal() {
    this.modalRef?.hide();
  }

  getPvList(){
    this.spinner.show();

    let startDate = this.searchForm.get('start_date')?.value
    if(startDate){
      startDate = this.datePipe.transform(startDate, 'yyyy-MM-dd');
    }

    let endDate = this.searchForm.get('end_date')?.value
    if(endDate){
      endDate = this.datePipe.transform(endDate, 'yyyy-MM-dd');
    }
    const params = {
      per_page: this.pageSize,
      page: this.currentPage,
      signature_status: this.searchForm.get('signature_status')?.value,
      consultant_name: this.searchForm.get('consultant_name')?.value,
      evaluation_name: this.searchForm.get('evaluation_name')?.value,
      evaluation_type: this.searchForm.get('evaluation_type')?.value,
      start_date: startDate,
      end_date: endDate
    }
    this.evaluationService
        .fetchPvList(params)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {
            if (res.status == 200) {
              this.pvList = res.data?.data
              this.totalElements = res.data?.total
              this.spinner.hide();
            }
          },
          error: (err) => {
            this.spinner.hide();
            if (err?.error) {
              this.toastrService.error(serverError);
            }
          },
        });
}

    /**
     * Handle page change event from the paginator.
     * @param event The page event containing the new page index and page size.
     */
    onPageChange(e: PageEvent): void {
        this.pageSize = e.pageSize;
        this.currentPage = e.pageIndex;
        this.getPvList()
}

 getSignatureStatusLabel(pv: any): string {
    return pv?.date_signature_esn ? "Signé par vous":
        pv?.date_signature_consultant ? "Signé par consultant" : "Non Signé";
  }

  getSignatureStatusClass(pv: any): string {
       return pv?.date_signature_esn ? 'sign-tag-esn':
        pv?.date_signature_consultant ? 'sign-tag-consultant' : 'sign-tag-none'
  }

  getDateByStatus(pv: any): string {
    return pv.signature_esn
      ? pv.date_signature_esn
      : pv.signature_consultant
      ? pv.date_signature_consultant
      : pv.date_report_filled;
  }

  getDateTooltip(pv: any): string {
    return pv.signature_esn
      ? "Date de signature entreprise"
      : pv.signature_consultant
      ? "Date de signature consultant"
      : "Date d'envoi";
  }
    
}
